import { Pencil, Trash2 } from "lucide-react";

export const OrderCard = ({ order: o, canWrite, canDelete, openEdit, onDelete }) => (
  <div
    data-testid={`order-card-${o.id}`}
    onClick={() => canWrite && openEdit(o)}
    role={canWrite ? "button" : undefined}
    tabIndex={canWrite ? 0 : undefined}
    className={`p-4 active:bg-[#f5f1ec] select-none ${canWrite ? "cursor-pointer" : ""}`}
  >
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        <div className="text-[10px] subtitle uppercase tracking-[0.2em] text-[#50493b] mb-1">
          Job / Freezer Number
        </div>
        <div className="font-semibold text-[#33424f] truncate">{o.job_number}</div>
        {o.description && (
          <div className="text-sm text-[#33424f] mt-2">{o.description}</div>
        )}
      </div>
      <span
        className={`text-[10px] font-semibold uppercase tracking-wider px-2 py-1 border shrink-0 ${
          o.active ? "text-[#2d5e1f] border-[#2d5e1f]/30 bg-[#e8f6e2]" : "text-[#50493b] border-[#50493b]/30 bg-[#f5f1ec]"
        }`}
      >
        {o.active ? "Active" : "Archived"}
      </span>
    </div>
    {(canWrite || canDelete) && (
      <div className="flex items-center justify-end gap-2 mt-4 pt-3 border-t border-[#33424f]/10" onClick={(e) => e.stopPropagation()}>
        {canWrite && (
          <button
            data-testid={`edit-order-card-${o.id}`}
            onClick={() => openEdit(o)}
            className="px-3 py-2 hover:bg-[#e6e0db] text-[#33424f] inline-flex items-center gap-1.5 text-xs subtitle uppercase tracking-[0.15em] border border-[#33424f]/20"
          >
            <Pencil className="w-3.5 h-3.5" /> Edit
          </button>
        )}
        {canDelete && (
          <button
            data-testid={`delete-order-card-${o.id}`}
            onClick={() => onDelete(o)}
            className="px-3 py-2 hover:bg-[#fbe4ea] text-[#b30035] inline-flex items-center gap-1.5 text-xs subtitle uppercase tracking-[0.15em] border border-[#b30035]/30"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    )}
  </div>
);
